module.exports = __webpack_public_path__ + "img/AICurated eco products.bccb8e20.png";